import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { IMAGES, CONTENT } from "../../const/config";
import { trackDownload, trackGuide, trackInstallFlow } from '../../analytics/tracking';
import InstallGuideModal from "./InstallGuideModal";

export default function PlatformDownload({ icon, title, directLink, storeLink }) {
  const [tab, setTab] = useState("store");
  const [showGuide, setShowGuide] = useState(false);

  const isDirect = tab === "direct";
  const isAndroid = title === "Android";
  const platformKey = isAndroid ? "android" : "ios";

  const handleTabSwitch = (t) => {
    setTab(t);
    trackInstallFlow(platformKey, "switch_tab", t);
  };

  const handleDownloadClick = () => {
    trackDownload(platformKey, tab);
  };

  const handleInstallGuideClick = (e) => {
    e.preventDefault();
    trackGuide(platformKey);
    setShowGuide(true);
  };

  const renderDownloadBadge = () => {
    if (isDirect) {
      const config = isAndroid
        ? { src: IMAGES.apkFile, alt: "APK", label: "Download by", name: "APK" }
        : { src: IMAGES.testFlight, alt: "TestFlight", label: "Download on", name: "TestFlight" };

      return (
        <div className="flex items-center gap-1.5 w-40 py-2 px-2 rounded-s bg-blue-600">
          <img src={config.src} className="w-8 h-8 object-contain" alt={config.alt} />
          <div className="flex flex-col leading-tight">
            <span className="text-xs font-light text-white">{config.label}</span>
            <span className="text-xs font-semibold text-white">{config.name}</span>
          </div>
        </div>
      );
    }

    const storeSrc = isAndroid ? IMAGES.googlePlay : IMAGES.appStore;
    const storeAlt = isAndroid ? "Google Play" : "App Store";

    return <img src={storeSrc} className="w-40 h-20 object-contain" alt={storeAlt} />;
  };

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="flex items-center gap-1.5 text-gray-700 font-semibold text-sm">
        {icon}
        <span>{title}</span>
      </div>

      <div className="flex gap-1 bg-gray-100 rounded-full p-0.5">
        {["store", "direct"].map((t) => (
          <button
            key={t}
            onClick={() => handleTabSwitch(t)}
            className={`px-3 py-1 text-xs font-medium rounded-full transition-all duration-200 ${tab === t
              ? "bg-blue-600 text-white shadow-sm"
              : "text-gray-500 hover:text-gray-700"
              }`}
          >
            {t === "direct"
              ? (isAndroid ? CONTENT.labels.apkVersion : CONTENT.labels.testFlight)
              : isAndroid
                ? "Google Play"
                : "App Store"}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-4">
        <div className="w-24 h-24 rounded-lg bg-white flex items-center justify-center p-1">
          {(isDirect ? directLink : storeLink) ? (
            <QRCodeSVG
              value={isDirect ? directLink : storeLink}
              size={88}
              level="M"
              aria-label={`${title} QR`}
            />
          ) : (
            <div
              className="w-8 h-8 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"
              role="status"
              aria-label="Đang tải QR"
            />
          )}
        </div>
        <div className="flex flex-col items-center gap-2">
          <a
            href={isDirect ? directLink : storeLink}
            target="_blank"
            rel="noreferrer"
            className="block hover:opacity-80 transition-opacity"
            onClick={handleDownloadClick}
          >
            {renderDownloadBadge()}
          </a>
        </div>
      </div>

      {/* Luôn giữ chỗ, chỉ ẩn/hiện bằng visibility */}
      <button
        className={`flex items-center justify-center gap-1.5 w-full px-4 py-2 bg-blue-600 text-white text-xs font-semibold rounded-md hover:bg-blue-700 transition-colors ${isDirect ? "visible" : "invisible"
          }`}
        onClick={handleInstallGuideClick}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        Hướng dẫn cài đặt
      </button>

      {showGuide && (
        <InstallGuideModal
          platform={platformKey}
          onClose={() => setShowGuide(false)}
        />
      )}
    </div>
  );
}